import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowRight, ExternalLink } from 'lucide-react';

// News data based on Ocean Peak actualité page
const newsData = [
  {
    id: 0,
    category: 'press-release',
    date: '2025-10-24',
    titleFr: "Lettre annuelle 2025",
    titleEn: "Annual Letter 2025",
    summaryFr: "La lettre annuelle d'Ocean Peak Capital pour l'année 2025.",
    summaryEn: "Ocean Peak Capital's annual letter for the year 2025.",
    image: 'https://customer-assets.emergentagent.com/job_dac2dc4e-4f19-40ab-966a-0ff854a140af/artifacts/2s65gmpx_Emblem.png',
    link: 'https://customer-assets.emergentagent.com/job_capital-connect-15/artifacts/y6ddwq0w_Ocean%20Peak%20Group%20-%202025%20Annual%20Letter.pdf',
    isPastNews: false,
    showInMedia: false
  },
  {
    id: 1,
    category: 'press-release',
    date: '2025-07-15',
    titleFr: "Lettre semestrielle 2025",
    titleEn: "2025 Mid-Year Investor Update",
    summaryFr: "La lettre semestrielle d'Ocean Peak Capital Partners pour le premier semestre 2025. Mise \u00e0 jour sur le portefeuille, le mod\u00e8le Ocean Peak et les perspectives macro\u00e9conomiques.",
    summaryEn: "Ocean Peak Capital Partners' mid-year investor letter for H1 2025. Updates on the portfolio, the Ocean Peak model, and macroeconomic outlook.",
    image: 'https://customer-assets.emergentagent.com/job_dac2dc4e-4f19-40ab-966a-0ff854a140af/artifacts/2s65gmpx_Emblem.png',
    link: '/OPK-Mid-Year-Letter-2025.pdf',
    isPastNews: false,
    showInMedia: false
  },
  {
    id: 8,
    category: 'press-release',
    date: '2025-01-15',
    titleFr: "Lettre annuelle 2024",
    titleEn: "Annual Letter 2024",
    summaryFr: "La lettre annuelle d'Ocean Peak Capital Partners pour l'ann\u00e9e 2024. Bilan de la premi\u00e8re ann\u00e9e du fonds, lancement et premier investissement dans Moret Industries.",
    summaryEn: "Ocean Peak Capital Partners' annual investor letter for 2024. Review of the fund's first year, launch and first investment in Moret Industries.",
    image: 'https://customer-assets.emergentagent.com/job_dac2dc4e-4f19-40ab-966a-0ff854a140af/artifacts/2s65gmpx_Emblem.png',
    link: '/OPK-Annual-Letter-2024.pdf',
    isPastNews: true,
    showInMedia: false
  },
  {
    id: 2,
    category: 'media',
    date: '2024-10-25',
    titleFr: "Ocean Peak recapitalise Moret Industries",
    titleEn: "Ocean Peak recapitalizes Moret Industries",
    summaryFr: "Moret Industries a achevé sa restructuration. Le fabricant de machines industrielles vient d'officialiser l'entrée à son capital d'un pool d'investisseurs mené par Ocean Peak Capital.",
    summaryEn: "Moret Industries has completed its restructuring. The industrial machinery manufacturer has just formalized the entry into its capital of a pool of investors led by Ocean Peak Capital.",
    image: 'https://cdn.prod.website-files.com/65e9e2270236397fb2e86a59/6720ffa7bbdbea61ec9dde5f_gettyimages-1507520853.webp',
    link: 'https://capitalfinance.lesechos.fr/deals/capital-developpement/trois-fonds-sinvitent-chez-moret-industries-2128307',
    source: 'Capital Finance (Les Echos)',
    isPastNews: true,
    showInMedia: true
  },
  {
    id: 3,
    category: 'media',
    date: '2024-10-24',
    titleFr: "Ocean Peak Capital se dévoile",
    titleEn: "Ocean Peak Capital unveils itself",
    summaryFr: "Un nouvel investisseur émerge, sous l'impulsion de trois experts de l'industrie et de l'ancien CEO de l'entité de Tikehau dédiée à l'aérospatiale et la défense.",
    summaryEn: "A new investor emerges, driven by three industry experts and the former CEO of Tikehau's aerospace and defense entity.",
    image: null,
    compositeImages: ['/F.Guillaume.jpg', '/F.Charles.jpg', '/F.Gregory.jpg'],
    link: 'https://www.cfnews.net/L-actualite/Marche-General/Vie-des-acteurs/Ocean-Peak-Capital-se-devoile-503875',
    source: 'CFNews',
    isPastNews: true,
    showInMedia: true
  },
  {
    id: 4,
    category: 'media',
    date: '2024-10-24',
    titleFr: "Moret industries se redéploie avec un first-time fund",
    titleEn: "Moret industries redeploys with a first-time fund",
    summaryFr: "Fort de 160 M€ de chiffre d'affaires, le fabricant axonais d'équipements industriels se prépare à accélérer sur la transition environnementale de l'industrie.",
    summaryEn: "With €160M in revenue, the Axonais industrial equipment manufacturer is preparing to accelerate the environmental transition of the industry.",
    image: 'https://cdn.prod.website-files.com/65e9e2270236397fb2e86a59/671f7132dcd89a0836f4013c_Moret-image-UNE.jpg',
    link: 'https://www.cfnews.net/L-actualite/Retournement/Operations/LBO-Capital-Developpement/Moret-industries-se-redeploie-avec-un-first-time-fund-503870',
    source: 'CFNews',
    isPastNews: true,
    showInMedia: true
  },
  {
    id: 5,
    category: 'media',
    date: '2024-10-24',
    titleFr: "Moret Industries accueille de nouveaux actionnaires majoritaires",
    titleEn: "Moret Industries welcomes new majority shareholders",
    summaryFr: "Le groupe familial Moret Industries, installé dans l'Aisne et spécialisé dans la conception et la fabrication d'équipements et de machines, vient d'ouvrir son capital.",
    summaryEn: "The Moret Industries family group, based in Aisne and specializing in the design and manufacture of equipment and machines, has just opened its capital.",
    image: 'https://cdn.prod.website-files.com/65e9e2270236397fb2e86a59/671ba64f98794f60081aead1_Moret-Industries-va-moderniser-ses-quipements-ap-998252.jpeg',
    link: 'https://www.lejournaldesentreprises.com/article/moret-industries-accueille-de-nouveaux-actionnaires-majoritaires-2106191',
    source: 'Le Journal des Entreprises',
    isPastNews: true,
    showInMedia: true
  },
  {
    id: 6,
    category: 'media',
    date: '2024-10-24',
    titleFr: "Moret Industries annonce un plan d'investissement de 7 millions d'euros sur cinq ans en France",
    titleEn: "Moret Industries announces €7 million investment plan over five years in France",
    summaryFr: "Le fabricant de machines industrielles Moret Industries a annoncé un investissement de 7 millions d'euros sur cinq ans en France.",
    summaryEn: "Industrial machinery manufacturer Moret Industries announced a €7 million investment over five years in France.",
    image: 'https://cdn.prod.website-files.com/65e9e2270236397fb2e86a59/671a5a7d50137bdc864870d0_moret%20(presse%20usine%20nouvelle).jpg',
    link: 'https://www.usinenouvelle.com/editorial/moret-industries-annonce-un-plan-d-investissement-de-7-millions-d-euros-sur-cinq-ans-en-france.N2221088',
    source: "L'Usine Nouvelle",
    isPastNews: true,
    showInMedia: true
  },
  {
    id: 7,
    category: 'press-release',
    date: '2024-10-24',
    titleFr: "Moret Industries accueille un consortium d'actionnaires pour soutenir sa stratégie de développement",
    titleEn: "Moret Industries welcomes a consortium of shareholders to support its development strategy",
    summaryFr: "Moret Industries renforce sa structure capitalistique avec l'entrée d'actionnaires majoritaires réunis dans un consortium autour d'Ocean Peak Capital.",
    summaryEn: "Moret Industries strengthens its capital structure with the entry of majority shareholders united in a consortium around Ocean Peak Capital.",
    image: 'https://cdn.prod.website-files.com/65e9e2270236397fb2e86a59/671a4f59dcdba62e2ae6a13e_moret%20communique%CC%81%20de%20press.jpeg',
    link: 'https://www.moretindustries.com/nouveau-consortium/',
    source: 'Moret Industries',
    isPastNews: true,
    showInMedia: false
  },
    {
    id: 9,
    category: 'press-release',
    date: '2026-07-08',
    titleFr: "Usiduc entre au portefeuille d’Ocean Peak",
    titleEn: "Usiduc Joins Ocean Peak's Portfolio",
    summaryFr: "Ocean Peak acquiert Usiduc, usineur de précision basé à Belfort, pour accélérer son développement au sein d’une plateforme dédiée à l’usinage de spécialité.",
    summaryEn: "Ocean Peak acquires Usiduc, a precision machining company based in Belfort, to accelerate its growth within a platform dedicated to specialty machining.",
    image: 'https://customer-assets.emergentagent.com/job_dac2dc4e-4f19-40ab-966a-0ff854a140af/artifacts/2s65gmpx_Emblem.png',
    link: '/2607_Usiduc-Communiqué_de_presse.pdf',
    isPastNews: false,
    showInMedia: true
  }
];

// News Card Component
const NewsCard = ({ item, language }) => {
  const title = language === 'fr' ? item.titleFr : item.titleEn;
  const summary = language === 'fr' ? item.summaryFr : item.summaryEn;
  const categoryLabel = item.category === 'media' 
    ? (language === 'fr' ? 'MÉDIA' : 'MEDIA')
    : (language === 'fr' ? 'COMMUNIQUÉ DE PRESSE' : 'PRESS RELEASE');
  
  const formattedDate = new Date(item.date).toLocaleDateString(language === 'fr' ? 'fr-FR' : 'en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }).toUpperCase();

  // Check if this card needs special image positioning (Annual Letter or Consortium)
  const needsImageOffset = item.id === 7; // Only Consortium needs offset now
  const needsSmallOffset = item.id === 0 || item.id === 1 || item.id === 8 || item.id === 9; // Annual Letters need smaller offset (moved up more)

  // Check if this card should NOT have grayscale (Annual Letters only)
  const noGrayscale = item.id === 0 || item.id === 1 || item.id === 8 || item.id === 9;

  return (
    <div 
      className="group bg-white border border-gray-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg flex flex-col h-full"
      style={{ fontFamily: "'Eurostile', 'Arial', sans-serif" }}
    >
      {/* Image */}
      <div className="aspect-[16/10] overflow-hidden bg-gray-100">
        {item.compositeImages ? (
          <div className="w-full h-full flex">
            {item.compositeImages.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={title}
                className={`h-full object-cover object-top transition-all duration-500 ${noGrayscale ? '' : 'grayscale group-hover:grayscale-0'}`}
                style={{ width: `${100 / item.compositeImages.length}%`, borderRight: i < item.compositeImages.length - 1 ? '1px solid black' : 'none', borderLeft: i > 0 ? '1px solid black' : 'none' }}
              />
            ))}
          </div>
        ) : (
          <img
            src={item.image}
            alt={title}
            className={`w-full h-full object-cover transition-all duration-500 ${noGrayscale ? '' : 'grayscale group-hover:grayscale-0'}`}
            style={{
              objectPosition: needsImageOffset ? 'center calc(50% + 70px)' : needsSmallOffset ? 'center calc(50% + 30px)' : 'center center'
            }}
          />
        )}
      </div>
      
      {/* Content */}
      <div className="p-6 flex flex-col flex-1">
        {/* Meta */}
        <p 
          className="text-xs mb-3"
          style={{ 
            fontFamily: "'Novecento Sans Wide', 'Arial', sans-serif",
            color: '#2a6cae',
            letterSpacing: '0.1em'
          }}
        >
          {categoryLabel} · {formattedDate}
        </p>
        
        {/* Title */}
        <h3 
          className="text-lg font-semibold mb-3 line-clamp-2 group-hover:text-[#2a6cae] transition-colors"
          style={{ 
            fontFamily: "'Eurostile', 'Arial', sans-serif",
            color: '#0a1f35',
            lineHeight: 1.3
          }}
        >
          {title}
        </h3>
        
        {/* Summary */}
        <p
          className="text-sm mb-4 line-clamp-3 flex-1"
          style={{
            fontFamily: "'Eurostile', 'Arial', sans-serif",
            color: '#5b6770',
            lineHeight: 1.6
          }}
        >
          {summary}
        </p>
        
        {/* Read More Link */}
        {item.link ? (
          <a 
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm group-hover:gap-3 transition-all"
            style={{ 
              fontFamily: "'Eurostile', 'Arial', sans-serif",
              color: '#2a6cae',
              fontWeight: 500
            }}
          >
            {language === 'fr' ? 'Lire la suite' : 'Read more'}
            <ArrowRight size={14} />
          </a>
        ) : (
          <span 
            className="inline-flex items-center gap-2 text-sm"
            style={{ 
              fontFamily: "'Eurostile', 'Arial', sans-serif",
              color: '#5b6770',
              fontWeight: 500
            }}
          >
            {language === 'fr' ? 'Contenu interne' : 'Internal content'}
          </span>
        )}
      </div>
    </div>
  );
};

// Media Link Item Component
const MediaLinkItem = ({ item, language }) => {
  const title = language === 'fr' ? item.titleFr : item.titleEn;
  
  const formattedDate = new Date(item.date).toLocaleDateString(language === 'fr' ? 'fr-FR' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div 
      className="py-4 border-b border-gray-200 last:border-b-0 hover:bg-gray-50 transition-colors px-4 -mx-4"
    >
      <p 
        className="text-xs mb-2"
        style={{ 
          fontFamily: "'Novecento Sans Wide', 'Arial', sans-serif",
          color: '#5b6770',
          letterSpacing: '0.05em'
        }}
      >
        {formattedDate} · {item.source}
      </p>
      <a 
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-base hover:text-[#2a6cae] transition-colors group"
        style={{ 
          fontFamily: "'Eurostile', 'Arial', sans-serif",
          color: '#0a1f35',
          fontWeight: 500
        }}
      >
        {title}
        <ExternalLink size={14} className="opacity-50 group-hover:opacity-100" />
      </a>
    </div>
  );
};

export const News = () => {
  const { language } = useLanguage();
  const [selectedTab, setSelectedTab] = useState('all');

  // Tab configuration
  const tabs = [
    {
      id: 'all',
      name: language === 'fr' ? 'Tous' : 'All'
    },
    {
      id: 'news',
      name: language === 'fr' ? 'Actualités' : 'News'
    },
    {
      id: 'media',
      name: language === 'fr' ? 'Média' : 'Media'
    }
  ];

  // Filter news based on selected tab
  const getFilteredNews = () => {
    switch (selectedTab) {
      case 'news':
        return newsData.filter(item => item.category !== 'media');
      case 'media':
        return newsData.filter(item => item.showInMedia && item.link);
      default:
        return newsData;
    }
  };

  const filteredNews = getFilteredNews();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f4f5f7', fontFamily: "'Eurostile', 'Arial', sans-serif" }}>
      {/* Hero Banner with Image */}
      <section 
        className="relative h-[400px] flex items-center justify-center overflow-hidden"
        style={{ backgroundColor: '#0a1f35' }}
      >
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(/hero-news.jpg)'
          }}
        />
        {/* Overlay - 30% opacity */}
        <div 
          className="absolute inset-0" 
          style={{ backgroundColor: 'rgba(10, 31, 53, 0.3)' }}
        />
        
        {/* Content */}
        <div className="relative z-10 text-center px-4">
          <h1
            className="text-6xl text-white mb-4"
            style={{
              fontFamily: "'Bank Gothic', 'Impact', sans-serif",
              fontWeight: 900,
              letterSpacing: '0.02em',
              textTransform: 'uppercase'
            }}
          >
            {language === 'fr' ? 'ACTUALITÉS' : 'NEWS'}
          </h1>
          <p
            className="text-xl lg:text-2xl text-white text-center max-w-4xl mx-auto font-bold"
            style={{
              fontFamily: "'Eurostile', 'Arial', sans-serif",
              lineHeight: 1.6
            }}
          >
            {language === 'fr'
              ? "L'actualité d'Ocean Peak Group : nos investissements, nos interventions, et nos convictions sur la transformation de l'industrie européenne."
              : "Our investments, our work on the ground, and our perspectives on European industrial transformation."}
          </p>
        </div>
      </section>

      {/* Tab Navigation - Same style as Team page */}
      <section className="border-b border-[#e5e5e5] py-6" style={{ backgroundColor: '#0a1f35' }}>
        <div className="max-w-[1400px] mx-auto px-10">
          <div className="flex items-center gap-2 flex-wrap">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setSelectedTab(tab.id)}
                className="px-6 py-3 text-[15px] font-medium transition-all duration-300 rounded"
                style={{
                  fontFamily: "'Eurostile', 'Arial', sans-serif",
                  fontWeight: selectedTab === tab.id ? 700 : 500,
                  backgroundColor: selectedTab === tab.id ? '#6b7280' : 'transparent',
                  color: selectedTab === tab.id ? '#ffffff' : 'rgba(255, 255, 255, 0.7)',
                  border: selectedTab === tab.id ? 'none' : '1px solid rgba(255, 255, 255, 0.3)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-10">
          
          {/* Media Tab - List View */}
          {selectedTab === 'media' && (
            <div className="animate-fade-in">
              <div className="bg-white p-8 shadow-sm">
                <h2 
                  className="text-xl mb-6 pb-4 border-b border-gray-200"
                  style={{ 
                    fontFamily: "'Novecento Sans Wide', 'Arial', sans-serif",
                    color: '#0a1f35',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}
                >
                  {language === 'fr' ? 'Couverture Médiatique' : 'Media Coverage'}
                </h2>
                
                {filteredNews.length > 0 ? (
                  <div>
                    {filteredNews
                      .sort((a, b) => new Date(b.date) - new Date(a.date))
                      .map((item) => (
                        <MediaLinkItem key={item.id} item={item} language={language} />
                      ))
                    }
                  </div>
                ) : (
                  <p className="text-center py-12 text-gray-500">
                    {language === 'fr' ? 'Aucun article média disponible.' : 'No media articles available.'}
                  </p>
                )}
              </div>
            </div>
          )}

          {/* Grid View for All and News */}
          {(selectedTab === 'all' || selectedTab === 'news') && (
            <div className="animate-fade-in">
              {filteredNews.length > 0 ? (
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {filteredNews
                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                    .map((item) => (
                      <NewsCard key={item.id} item={item} language={language} />
                    ))
                  }
                </div>
              ) : (
                <p className="text-center py-12 text-gray-500">
                  {language === 'fr' ? 'Aucune actualité disponible.' : 'No news available.'}
                </p>
              )}
            </div>
          )}

        </div>
      </section>

      {/* LinkedIn Posts Section */}
      <section className="py-16" style={{ backgroundColor: '#0a1f35' }}>
        <div className="max-w-[1400px] mx-auto px-10">
          <h2
            className="text-2xl text-white mb-8"
            style={{
              fontFamily: "'Novecento Sans Wide', 'Arial', sans-serif",
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}
          >
            {language === 'fr' ? 'SUIVEZ NOUS ET NOS SOCIÉTÉS SUR LINKEDIN' : 'FOLLOW US AND OUR PORTFOLIO COMPANIES ON LINKEDIN'}
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { name: 'Ocean Peak Group', url: 'https://www.linkedin.com/company/oceanpeak-capital-sas/' },
              { name: 'Moret Industries', url: 'https://www.linkedin.com/company/moret-industries/' },
              { name: 'VetterTec', url: 'https://www.linkedin.com/company/vettertec/' },
              { name: 'Fapmo', url: 'https://www.linkedin.com/company/fapmo/' },
              { name: 'Maguin', url: 'https://fr.linkedin.com/company/maguin-sas' },
              { name: 'DeSmet', url: 'https://www.linkedin.com/company/desmet/' },
              { name: 'TCEM', url: 'https://fr.linkedin.com/company/tcem' },
              { name: 'OPEO', url: 'https://fr.linkedin.com/company/opeo' }
            ].map((company, idx) => (
              <a
                key={idx}
                href={company.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group p-6 border border-white/20 hover:border-white/50 transition-all duration-300 hover:bg-white/5"
              >
                <div className="flex items-center gap-3 mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#2a6cae]">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                    <rect width="4" height="12" x="2" y="9"/>
                    <circle cx="4" cy="4" r="2"/>
                  </svg>
                  <span
                    className="text-white font-medium"
                    style={{ fontFamily: "'Eurostile', 'Arial', sans-serif" }}
                  >
                    {company.name}
                  </span>
                </div>
                <p
                  className="text-white/60 text-sm group-hover:text-white/80 transition-colors"
                  style={{ fontFamily: "'Eurostile', 'Arial', sans-serif" }}
                >
                  {language === 'fr' ? 'Voir sur LinkedIn →' : 'View on LinkedIn →'}
                </p>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom Spacer */}
      <div className="h-24"></div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fadeIn 0.4s ease-out;
        }
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};
